var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoSeguent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 0h30v30H.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 3.75a11.25 11.25 0 1 0 0 22.5c6.213 0 11.25-5.037 11.25-11.25S21.713 3.75 15.5 3.75M20.5 15l-5-5M20.5 15h-10M15.5 20l5-5",
    stroke: "#FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSeguent);
export default __webpack_public_path__ + "static/media/ico-seguent.ec8ab22388a50aea2cb865b77e953531.svg";
export { ForwardRef as ReactComponent };